import { Competition } from 'business';
import { useQuery } from 'bridge';

export default function useRecentGroupCompetitions(clubId: string, now?: Date) : Competition[] | undefined {

    const groupCompetitions = useQuery<Competition>({ clubId: clubId, queryType: 'recentClubCompetitions', date: now});
    return groupCompetitions;
}

